import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var LockIcon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#171717"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 18.872a1.5 1.5 0 011.5-1.5h28.723a1.5 1.5 0 011.5 1.5v13.56a1.5 1.5 0 01-3 0v-12.06H3.5v12.06c0 3.412 2.629 6.068 5.666 6.068h17.383a1.5 1.5 0 110 3H9.166C4.32 41.5.5 37.345.5 32.432v-13.56zM16.361 3.5c-5.387 0-9.891 4.636-9.891 10.53a1.5 1.5 0 11-3 0C3.47 6.637 9.165.5 16.36.5s12.891 6.136 12.891 13.53a1.5 1.5 0 11-3 0c0-5.894-4.504-10.53-9.891-10.53z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.232 32.928c.177.187.39.262.639.262a.831.831 0 00.638-.262l5.32-5.618c.354-.374.354-.974 0-1.31-.355-.375-.923-.375-1.242 0l-4.716 4.943-2.908-3.07c-.354-.375-.922-.375-1.241 0-.355.374-.355.973 0 1.31l3.51 3.745z",
    fill: "#16CA92",
    stroke: "#16CA92"
  }));
});
LockIcon.displayName = 'LockIcon';

export { LockIcon, LockIcon as default };
